export default class {
    cutStringAndAppendEnding (string, cutAfterChar = 145, appendString = '...') {
        if (string.length <= cutAfterChar) {
            return string;
        }

        return string.substr(0, cutAfterChar) + appendString;
    }

    /**
     * This function will translate new lines from textarea to html tag br
     * @param text
     * @returns {string}
     */
    changeNewLineToBr (text) {
        const breakTag = '</br>';
        return text.replace(/([^>\r\n]?)(\r\n|\n\r|\r|\n)/g, `$1${breakTag}$2`);
    }
}



// WEBPACK FOOTER //
// ./src/app/services/string/index.js